import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import authAPI from 'apis/authAPI';
import LoadingSpinner from 'components/utils/LoadingSpinner';

const CunexCallback: React.FC = () => {
  const [searchParams] = useSearchParams();
  const location = useLocation();
  const navigate = useNavigate();
  const [error, setError] = useState('');

  useEffect(() => {
    const token = searchParams.get('token');
    const userType = location.pathname.includes('/staff/')
      ? 'staff'
      : location.pathname.includes('/student/')
        ? 'student'
        : undefined;

    if (!token) {
      setError('CUNEX did not return an authentication token.');
      return;
    }

    const isVirtualTeacherLogin = document.cookie
      .split('; ')
      .some((cookie) => cookie === 'cunexLoginApp=virtual-teacher')
      || sessionStorage.getItem('cunexLoginApp') === 'virtual-teacher';

    if (isVirtualTeacherLogin) {
      document.cookie = 'cunexLoginApp=; Path=/; Max-Age=0; SameSite=Lax';
      sessionStorage.removeItem('cunexLoginApp');
      const virtualTeacherCallback = `/virtual-teacher${location.pathname}${location.search}`;
      window.location.replace(virtualTeacherCallback);
      return;
    }

    const completeLogin = async () => {
      const response = await authAPI.cunexCallback({ token, ...(userType ? { userType } : {}) });
      if (response.error || response.statusCode !== 200 || !response.data?.accessToken) {
        setError(response.error || 'CUNEX login failed.');
        return;
      }

      localStorage.setItem('token', response.data.accessToken);
      const redirectPath = localStorage.getItem('redirectAfterLogin') || '/';
      localStorage.removeItem('redirectAfterLogin');
      navigate(redirectPath);
    };

    completeLogin().catch(() => setError('CUNEX login failed.'));
  }, [location.pathname, navigate, searchParams]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-grad-pk-bl px-4">
      <div className="rounded-2xl bg-white p-10 text-center shadow-2xl">
        {error ? (
          <>
            <p className="mb-5 text-red-700">{error}</p>
            <Link to="/signin" className="text-BADBlue underline">Return to sign in</Link>
          </>
        ) : (
          <>
            <div className="mb-3 flex justify-center"><LoadingSpinner /></div>
            <p className="text-BADBlue">Completing CUNEX sign in...</p>
          </>
        )}
      </div>
    </div>
  );
};

export default CunexCallback;